import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useState } from "react";

import AppTextField, { type AppTextFieldProps } from "../AppTextField";

export function AppPasswordInput(props: AppTextFieldProps) {
  const [visibility, setVisibility] = useState(false);
  return (
    <AppTextField
      {...props}
      type={visibility ? "text" : "password"}
      InputProps={{
        endAdornment: visibility ? (
          <IconButton
            disabled={props.disabled}
            style={{
              padding: "4px"
            }}
            onClick={() => setVisibility(false)}
          >
            <VisibilityOff style={{ color: "#0005" }} />
          </IconButton>
        ) : (
          <IconButton
            style={{ padding: "4px" }}
            onClick={() => setVisibility(true)}
          >
            <Visibility style={{ color: "#0005" }} />
          </IconButton>
        )
      }}
    />
  );
}
